import {useState, useEffect} from "../../../__snowpack__/pkg/react.js";
import {axios} from "../../lib/axios.js";
import {handleError} from "../../lib/errorHandler.js";
export const useAddProductTableData = (orderType) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (pageInfo, search) => {
    setLoading(true);
    try {
      let data2;
      if (orderType === "OUTBOUND") {
        if (search) {
          search.stockStatus = "TOTAL";
          if (search.keywordType === "SKU" || search.keywordType === "SKU_IG_CASE") {
            search.masterSku = search.keyword || "";
          } else if (search.keywordType === "NAME") {
            search.name = search.keyword || "";
          }
          delete search.keyword;
          delete search.keywordType;
          delete search.variationType;
          delete search.isInventoryDistribution;
        }
        const res = await axios.post("/saas/warehouseInventories/search", {
          page: pageInfo && pageInfo.page && pageInfo.page - 1,
          size: pageInfo && pageInfo.pageSize,
          ...search
        });
        data2 = res && res.data;
      } else {
        const res = await axios.post("/saas/warehouseInventories/addInbound/search", {
          page: pageInfo && pageInfo.page && pageInfo.page - 1,
          size: pageInfo && pageInfo.pageSize,
          ...search
        });
        data2 = res && res.data;
      }
      if (!data2) {
        data2 = {
          content: [],
          number: 0,
          size: 150,
          totalElements: 0
        };
      }
      const {content, number: page, size: pageSize, totalElements: pageTotal} = data2;
      setData(content);
      return {
        tableData: content,
        pageInfo: {
          page: page + 1,
          pageSize,
          pageTotal
        }
      };
    } catch (error) {
      handleError(error);
      return {
        tableData: data,
        pageInfo
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    tableDataLoading: loading,
    tableData: data,
    setTableData: setData,
    fetchTableData: fetchData
  };
};
export const useGetShelfByWarehouseId = ({warehouseId}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axios.post("/saas/warehouseShelves/search", {
        page: 0,
        size: 15,
        warehouseId: warehouseId || ""
      });
      let data2 = [];
      if (res && res.code === "SUCCESS") {
        if (res.data && Array.isArray(res.data.content)) {
          data2 = res.data.content;
        }
        setData(data2);
      }
      return {data: data2};
    } catch (error) {
      handleError(error);
      return error;
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  return {
    loading,
    data,
    fetchData
  };
};
